import { mapState, mapMutations } from 'vuex'
import { MODULE_NAME, MUTATIONS } from '@/store/filters/constants'
import apiService from '@/api/apiService'

export default {
  name: 'ShopsList',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      shops: [],
      viewport: false
    }
  },
  computed: {
    ...mapState(MODULE_NAME, ['filters']),
    nameFilter () {
      return this.filters.find(f => f.key === 'fulltext').value
    },
    viewportFilter () {
      return this.filters.find(f => f.key === 'viewport')
    },
    viewportFilterEnabled () {
      return this.viewportFilter.enabled
    },
    shopList () {
      return this.viewportFilter.enabled
        ? this.viewportFilter.value
        : this.shops
    },
    filteredShops () {
      return this.shopList.filter(shop => this.filterShopByName(shop))
    }
  },
  watch: {},
  mounted () {
    this.fetchShops()
  },
  beforeDestroy () {
    this.clearFilters()
  },
  methods: {
    ...mapMutations(MODULE_NAME, Object.values(MUTATIONS)),
    async fetchShops () {
      this.loading = true
      try {
        const data = await apiService.getShopList()
        this.shops = data
      } catch (err) {
        // eslint-disable-next-line
        console.error('[shops-list.js] Error fetching centers', err)
      }
      this.loading = false
    },
    onSwitchChange () {
      const flag = !this.viewportFilterEnabled
      this[MUTATIONS.TOGGLE_FILTER]({ key: 'viewport', value: flag })
      if (flag === false) {
        this[MUTATIONS.SET_FILTER_VALUE]({ key: 'viewport', value: [] })
      }
    },
    clearFilters () {
      this[MUTATIONS.CLEAR_ALL_FILTERS]()
    },
    filterShopByName (shop) {
      if (!this.nameFilter) {
        return true
      }
      const name = shop.local.toLowerCase()
      const query = this.nameFilter.toLowerCase()
      return name.indexOf(query) !== -1
    }
  }
}
